<main class="admin-portal">

  <!-- =========================================================
       HERO
       ========================================================= -->

  <header class="portal-hero">

    <div>
      <span class="eyebrow">
        Website Management
      </span>

      <h1>
        Website Administration
      </h1>

      <p>
        Manage the public website from one secure workspace.
      </p>
    </div>

    <div
      class="admin-badge"
      aria-label="Signed in as administrator"
    >
      <span class="status-dot"></span>
      Administrator
    </div>

  </header>


  <!-- =========================================================
       MAIN LAYOUT
       ========================================================= -->

  <div class="portal-layout">

    <!-- =========================================================
         SIDEBAR
         ========================================================= -->

    <aside
      class="portal-sidebar"
      aria-label="Admin sections"
    >

      <div class="sidebar-title">
        Admin Portal
      </div>

      <nav>

        <button
          *ngFor="let item of navigation"
          type="button"
          class="nav-item"
          [class.active]="activeSection === item.id"
          (click)="selectSection(item.id)"
        >

          <span
            class="nav-icon"
            [attr.data-icon]="item.id"
          ></span>

          <span>
            <strong>
              {{ item.label }}
            </strong>

            <small>
              {{ item.description }}
            </small>
          </span>

          <span class="nav-arrow">
            ›
          </span>

        </button>

      </nav>

      <div class="sidebar-help">

        <strong>
          Need website help?
        </strong>

        <p>
          Contact your website administrator before
          changing unfamiliar settings.
        </p>

      </div>

    </aside>


    <!-- =========================================================
         CONTENT
         ========================================================= -->

    <section class="portal-content">

      @if (activeSection === 'overview') {
        <app-admin-overview
          (sectionSelected)="selectSection($event)"
        />
      }

      @if (activeSection === 'home') {
        <app-admin-home />
      }

      @if (activeSection === 'about') {
        <app-admin-about />
      }

      @if (activeSection === 'youtube') {
        <app-admin-youtube />
      }

      @if (activeSection === 'locations') {
        <app-admin-locations />
      }
      
      @if (activeSection === 'social') {
        <app-admin-social />
      }

      @if (activeSection === 'community') {
        <app-admin-community />
      }

      @if (activeSection === 'staff') {
        <app-admin-staff />
      }

      @if (activeSection === 'whitelist') {
        <app-admin-whitelist />
      }

      @if (activeSection === 'settings') {
        <app-admin-settings />
      }

    </section>

  </div>

</main>